import {Component, Input} from '@angular/core';
import {AutofocusDirective} from '../../../../../common/directive/autofocus.directive';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-sex-button',
  imports: [
    AutofocusDirective,
    NgIf
  ],
  templateUrl: './sex-button.component.html'
})
export class SexButtonComponent {

  @Input()
  label: string

  @Input()
  selected: boolean
}
